export default {
  BLUR_FIELD: 'BLUR_FIELD',
  DESTROY_FIELD: 'DESTROY_FIELD',
  FOCUS_FIELD: 'FOCUS_FIELD',
  INITIALIZE_FIELD: 'INITIALIZE_FIELD',
  SYNC_FIELD: 'SYNC_FIELD',
  UPDATE_FIELD: 'UPDATE_FIELD',
  SUBMIT_FORM: 'SUBMIT_FORM',
};



// WEBPACK FOOTER //
// ./src/features/Form/constants.js